<script>
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';
    import Mobilebtn2 from '../mobilebtn2.svelte';

    let main;
    let div1;
    let div2;
    let div3;
    let div4;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            div1,
            [
                {translateY: 0, duration: 1},
                {translateY: 0, duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            div2,
            [
                {translateY: 0, duration: 1},
                {translateY: 0, duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            div3,
            [
                {translateY: 0, duration: 1},
                {translateY: 0, duration: 1},
            ],
            3,
        );
        // initializeGsapAnimation(
        //     main,
        //     div4,
        //     [
        //         {translateY: 0, duration: 1},
        //         {translateY: '-54.019vw', duration: 1},
        //     ],
        //     3,
        // );
    }
</script>

<section>
    <div class="main" bind:this={main}>
        <div class="container">
            <div class="first" bind:this={div1}>
                <p class="textfirst">
                    We are <strong>building the future of games</strong> where games
                    are not merely designed and published by producers but are a
                    collaborative narrative agreed upon and voted on by the community.
                </p>
            </div>
            <div class="second" bind:this={div2}>
                <hr
                    style="width: 100%;
            border: 0.234vw solid #000000;"
                />
            </div>
            <div class="third" bind:this={div3}>
                <p>
                    Learn what it is like to play in an ever changing world in
                    which you aren’t merely a player and also a creator and
                    administrator.
                </p>
            </div>
            <!-- <div> -->
            <!-- <button>Join Games Governance Council</button> -->
            <div class="fourth" bind:this={div4}>
                <Mobilebtn2
                    text="Join Games Governance Council"
                    bgcolor="#615bff"
                    width="60.748vw"
                    height="10.047vw"
                    state='Games'
                />
            </div>
            <!-- </div> -->
            <div class="arrow">
                <p class="ar">></p>
            </div>
        </div>
    </div>
</section>

<style>
    .main {
        width: 100%;
        background-color: #f4eeec;
        height: max(100vh, 216vw);
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        position: relative;
    }
    .arrow {
        height: 2.336vw;
        width: 5.841vw;
        margin: auto;
        margin-top: max(6.048vh, 13.16vw);
    }
    .ar {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 4.673vw;
        line-height: 5.841vw;
        letter-spacing: 0.06em;
        color: #000000;
        transform: rotate(90deg);
    }
    .fourth {
        box-sizing: border-box;
    }
    .third {
        margin: auto;
        width: 84.579vw;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 3.271vw;
        text-align: center;
        letter-spacing: 0.06em;
        color: #000000;
        margin-bottom: max(6.479vh, 14.01vw);
    }
    .second {
        width: 61.916vw;
        margin-bottom: max(9.719vh, 21.02vw);
    }
    .first {
        margin: auto;
        width: 82.944vw;
        margin-bottom: max(8.099vh,17.52vw);
        margin-top: max(21.814vh, 47.19vw);
        position: relative;
    }
    .textfirst {
        margin-top: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 500;
        font-size: 5.607vw;
        line-height: 140%;
        letter-spacing: 0.06em;
        color: #000000;
    }
    .textfirst strong {
        font-weight: 900;
    }
    p {
        margin: 0;
    }
</style>
